<template>
  <div 
    :class="'file-download-link' 
      + (extraClasses ? ' ' + extraClasses : '') 
      + (loading ? ' loading' : '')"
  >
    <a 
      :href="href" 
      :download="fileName"
      :class="linkClass + (loading ? ' disabled' : '')"
      :id="linkID"
      :disabled="loading"
      ref="fileDownloadLink"
      :aria-busy="loading"
      :aria-describedby="(loading && progressBar) ? progressBarID : false"
      @click="onLinkClick"
    >
      <i :class="['fas', iconClass]"/>
      <span>{{ text }}</span>
    </a>
    <div 
      v-if="progressBar && loading" 
      class="progress-bar"
      role="progressbar"
      :aria-valuemin="0"
      :aria-valuemax="100"
      :aria-valuenow="Math.round(progress * 100)"
      :aria-valuetext="progressBarText"
    >
      <span class="progress-bar-description">{{ progressBarText }}</span>
      <span
        v-if="progress"
        class="progress-bar-progress"
        :style="{
          width: (progress * 100) + '%'
        }"
      >{{ Math.round(progress * 100) }}%</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    alerts: {
      type: Boolean,
      default: true
    },
    errorText: {
      type: String,
      default: 'There was a problem downloading the file. Please refresh the page and try again.'
    },
    extraClasses: {
      type: String,
      default: ''
    },
    iconClass: {
      type: String,
      default: 'fa-file-download'
    },
    linkClass: {
      type: String,
      default: 'btn btn-secondary'
    },
    progressBarID: {
      type: String,
      default: 'file-download-progress'
    },
    progressBar: {
      type: Boolean,
      default: true,
    },
    progressBarText: {
      type: String,
      default: 'Preparing file...'
    },
    src: {
      type: String,
      required: true
    },
    text: {
      type: String,
      default: 'Download'
    }
  },
  computed: {
    basename() {
      const name = this.href || this.src;
      if(!name) {
        return '';
      }
      return name.split('/').reverse()[0];
    }
  },
  data() {
    return {
      fileName: '',
      href: '',
      loading: false,
      progress: 0
    }
  },
  methods: {
    onLinkClick(e) {
      if(this.loading) {
        e.preventDefault();
        return;
      }
      if(this.href) {
        setTimeout(() => {
          this.href = '';
        }, 250);
        return;
      }
      e.preventDefault();
      this.loading = true;
      this.progress = 0;
      this.$emit('download-started', {
        src: this.src
      });
      this.$http
        .get(this.src, {
          responseType: 'arraybuffer',
          onDownloadProgress: (progressEvent) => {
            this.progress = progressEvent.total 
              ? (progressEvent.loaded / progressEvent.total) 
              : (progressEvent.loaded ? 1 : 0);
            this.$emit('download-progress', {
              src: this.src,
              progressEvent
            });
          }
        })
        .then((response) => {
          const blob = new Blob([response.data]);
          let fileName = this.basename;
          
          if(response.headers && response.headers['content-disposition']) {
            const fileNameMatch = response.headers['content-disposition'].match(/filename="([^"]+)/);
            if(fileNameMatch) {
              fileName = fileNameMatch[1];
            }
          }
          const fileURL = window.URL.createObjectURL(blob);
          
          this.fileName = fileName;
          this.href = fileURL;
          setTimeout(() => {
            this.$refs.fileDownloadLink.click();
          }, 250);
          this.$emit('download-completed', {
            href: this.href,
            src: this.src,
            fileName
          });
        })
        .catch(error => {
          console.error(error);
          this.$emit('download-failed', {
            src: this.src,
            error
          });
          if(this.alerts) {
            alert(this.errorText);
          }
        })
        .finally(() => {
          this.loading = false;
          this.$emit('download-stopped', {
            src: this.src
          });
        });
    }
  }
}
</script>
<style lang="scss">
  .file-download-link {
    &.loading {
      a {
        cursor: wait !important;
      }
    }
    .progress-bar {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      background-color: #333;
      color: #fff;
      z-index: 9999;
    }
    .progress-bar-description {
      display: block;
      padding: 12px;
      z-index: 1;
    }
    .progress-bar-progress {
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      padding: 12px;
      background-color: rgb(111, 228, 111);
      z-index: 2;
      box-sizing: border-box;
    }
  }
</style>